<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Swal from "sweetalert2";
import Multiselect from "vue-multiselect";

import axios from "axios";
import { required } from "vuelidate/lib/validators";
import { requiredIf } from "vuelidate/lib/validators";

/**
 * Contacts-list component
 */
export default {
  page: {
    title: "Users List",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, Multiselect },
  data() {
    return {
      userGridData: {
        data: [],
        total: 0,
      },
      title: "Users List",
      model: "User",
      items: [
        {
          text: "Dashboard",
          href: "/dashboard"
        },
        {
          text: 'Users List',
          active: true
        }
      ],
      submitted: false,
      theads: ["#", "Name", "Role", "Contact No", "Gender", "Action"],
      isLoadingGetList: false,
      isLoadingPost: false,
      filter: {
        paginate_count: 10,
        page: 1,
      },
      selected_user: {
        username: null,
        name: null,
        password: null,
        contact_no: null,
        gender_id: null,
        role_id: null,
        rooms: [],
      },
      passwordType: 'password',
      roles: [],
      genders: [],
      token: null,
      modal_type: 'create',
      roomList: [],
    };
  },
  validations: {
    selected_user: {
      username: { required },
      password: { 
        required: requiredIf(function() {
          return this.modal_type == 'create';
        })
      },
      name: { required },
      role_id: { required },
    },
  },
  async mounted(){
    
    this.token = await localStorage.getItem('authToken')

    this.getList();
    this.getRoles();
    this.getGenders();
    this.getRoomList();
  },
  watch: {
    'filter.page': function(){
      this.getList();
    }
  },
  methods: {
    getRoomList(){
      //fetch data from API
      axios.get(process.env.VUE_APP_API + '/room/getIndex', {
        headers: {
          Authorization: 'Bearer ' + this.token
        }
      })
      .then(res => {
        this.roomList = res.data.data;
      })
    },
    renderModalTitle(){
      return (this.selected_user.id ? 'Edit Data' : 'Create New') + ' ' + this.model;
    },
    getRoles(){
      axios.get(process.env.VUE_APP_API + '/role')
      .then(res => {
        this.roles = res.data.data;
      })
      .catch(err => {
        this.err = err;
      });
    },
    getGenders(){
      axios.get(process.env.VUE_APP_API + '/gender')
      .then(res => {
        this.genders = res.data.data;
      })
      .catch(err => {
        this.err = err;
      });
    },
    formSubmit(e) {
      this.submitted = true;
      // stop here if form is invalid
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      }

      this.isLoadingPost = true;

      let url = process.env.VUE_APP_API + '/user'
      let data = this.selected_user;
      data.room_ids = [];

      this.selected_user.rooms.map((room, index) => {
        data.room_ids.push(room.id);
      });

      let success_message = 'Successfully create new user';

      if(this.modal_type == 'edit'){
        url = url + '/' + this.selected_user.id;
        data._method = 'PUT';
        success_message = 'Successfully update user data';
      }

      axios.post(url, data, {
        headers: {
          Authorization: 'Bearer ' + this.token 
        }
      })
      .then((res) => {
        Swal.fire("Success!", success_message, "success");
        this.$bvModal.hide('modal-user');
        this.getList();
      })
      .catch((err) => {
        console.log(err);
        this.err = err;
      })
      .finally(() => {
        this.isLoadingPost = false;
        this.submitted = false;
      });
    },
    onEdit(user){
      this.modal_type = 'edit';
      this.submitted = false;
      this.selected_user = JSON.parse(JSON.stringify(user));
      this.$bvModal.show('modal-user');
    },
    onDelete(user){
      Swal.fire({
        title: "Delete user (" + user.name + ")?",
        text: "Disactivate selected user. You can restore it later!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, delete it!"
      }).then(result => {
        if (result.value) {
          axios.post(process.env.VUE_APP_API + '/user/' + user.id, {
            _method: 'DELETE'
          }, {
            headers: {
              Authorization: 'Bearer ' + this.token
            }
          })
          .then(res => {
            Swal.fire("Deleted!", user.name + ' has been removed', "success");
            this.getList();
          })
        }
      });
    },
    onRestore(user){
      Swal.fire({
        title: "Restore user (" + user.name + ")?",
        text: "You are going to restore selected user and grant the access as '"+ user.role +"'!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, restore access!"
      }).then(result => {
        if (result.value) {
          axios.post(process.env.VUE_APP_API + '/user/' + user.id + '/restore', {
            _method: 'PUT'
          }, {
            headers: {
              Authorization: 'Bearer ' + this.token
            }
          })
          .then(res => {
            Swal.fire("Restored!", user.name + "'s access has been restored", "success");
            this.getList();
          })
        }
      });
    },
    getList(){
      this.isLoadingGetList = true;

      //fetch data from API
      axios.get(process.env.VUE_APP_API + '/user?page=' + this.filter.page + '&paginate_count=' + this.filter.paginate_count, {
        headers: {
          'Authorization': 'Bearer ' + this.token
        }
      })
      .then(res => {
        this.userGridData = res.data.data;
      })
      .catch(err => {
        this.err = err;
      })
      .finally(() => {
        this.isLoadingGetList = false;
      });
    },
    onClickCreate(){
      this.modal_type = 'create';
      this.submitted = false;
      this.selected_user = {
        username: null,
        name: null,
        contact_no: null,
        gender: null,
        role_id: null,
        rooms: []
      };

      this.$bvModal.show('modal-user');
    }
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="right">
              <b-button @click="onClickCreate()" variant="primary">Create New {{ this.model }}</b-button>
            </div>
            <div class="table-responsive mt-2">
              <table class="table align-middle table-nowrap table-hover">
                <thead class="table-light">
                  <tr>
                    <th scope="col" v-for="(thead, index) in theads" :key="`head_${index}`">{{thead}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="n in 3" :key="`loading_tr_${n}`" v-if="isLoadingGetList">
                    <td class="placeholder-glow" v-for="i in theads.length" :key="`placeholder_${i}`"><span class="placeholder col-12 placeholder-lg"></span></td>
                  </tr>
                  <tr v-for="list in userGridData.data" :key="list.id" v-if="!isLoadingGetList">
                    <td>
                      <div class="avatar-xs">
                        <span class="avatar-title rounded-circle">{{list.name.charAt(0)}}</span>
                      </div>
                    </td>
                    <td>
                      <h5 class="font-size-14 mb-1">
                        <span :class="list.is_deleted ? 'text-danger' : 'text-dark'">{{list.name}}</span>
                      </h5>
                      <p :class="`small ${list.is_deleted ? 'text-danger' : 'text-muted'} mb-0`">{{list.username}}</p>
                    </td>
                    <td :class="`${list.is_deleted ? 'text-danger' : 'text-dark'}`">{{list.role}}</td>
                    <td>
                      <span v-if="list.contact_no">{{list.contact_no}}</span>
                      <span v-else><i :class="`small ${list.is_deleted ? 'text-danger' : 'text-muted'}`">No contact number</i></span>
                    </td>
                    <td>
                      <span v-if="list.gender_id">{{list.gender}}</span>
                      <span v-else><i :class="`small ${list.is_deleted ? 'text-danger' : 'text-muted'}`">No gender selected</i></span>
                    </td>
                    <td>
                      <ul class="list-inline font-size-20 contact-links mb-0">
                        <li class="list-inline-item px-2 cursor-pointer" @click="onEdit(list)" v-if="!list.is_deleted">
                          <a v-b-tooltip.hover title="Edit" class="font-size-14">
                            <i class="bx bx-edit text-primary"></i> Edit
                          </a>
                        </li>
                        <li class="list-inline-item px-2 cursor-pointer" @click="onDelete(list)" v-if="!list.is_deleted">
                          <a v-b-tooltip.hover title="Delete" class="font-size-14">
                            <i class="bx bx-trash-alt text-danger"></i> Delete
                          </a>
                        </li>
                        <li class="list-inline-item px-2 cursor-pointer" @click="onRestore(list)" v-if="list.is_deleted">
                          <a v-b-tooltip.hover title="Restore" class="font-size-14">
                            <i class="mdi mdi-delete-restore text-success"></i> Restore
                          </a>
                        </li>
                      </ul>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="row mt-3">
              <div class="col-lg-12">
                <b-pagination
                  v-model="filter.page"
                  :total-rows="userGridData.total"
                  :per-page="filter.paginate_count"
                  aria-controls="my-table"
                  align="center"
                ></b-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal id="modal-user" :title="renderModalTitle()" title-class="font-18" hide-footer>
      <form class="needs-validation" @submit.prevent="formSubmit">
        <div class="row">
          <div class="col-md-12">
            <div class="mb-3">
              <label for="inputField1">Username <span class="text-danger small">*</span></label>
              <input
                id="inputField1"
                v-model="selected_user.username"
                type="text"
                class="form-control"
                placeholder="Use for login e.g. ronni123"
                :class="{
                  'is-invalid': submitted && $v.selected_user.username.$error,
                }"
              />
              <div v-if="submitted && $v.selected_user.username.$error" class="invalid-feedback">
                <span v-if="!$v.selected_user.username.required">Username is required.</span>
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div class="mb-3">
              <label for="inputField2">Password <span class="text-danger small">*</span></label>
              <input
                id="inputField2"
                v-model="selected_user.password"
                :type="passwordType"
                class="form-control"
                placeholder="Password"
                :class="{
                  'is-invalid': submitted && $v.selected_user.password.$error,
                }"
              />
              <span class="small text-muted" v-if="modal_type == 'edit'">Enter new password to reset current password</span>
              <div v-if="submitted && $v.selected_user.password.$error" class="invalid-feedback">
                <span v-if="!$v.selected_user.password.required">Password is required.</span>
              </div>
              <b-form-checkbox v-model="passwordType" value="text" unchecked-value="password" class="mt-1">
                <span class="ps-2">Show Password</span>
              </b-form-checkbox>
            </div>
          </div>
          <div class="col-md-6">
            <div class="mb-3">
              <label for="inputField3">Name <span class="text-danger small">*</span></label>
              <input
                id="inputField3"
                v-model="selected_user.name"
                type="text"
                class="form-control"
                placeholder="Reflect to User"
                :class="{
                  'is-invalid': submitted && $v.selected_user.name.$error,
                }"
              />
              <div v-if="submitted && $v.selected_user.name.$error" class="invalid-feedback">
                <span v-if="!$v.selected_user.name.required">Name is required.</span>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="mb-3">
              <label for="inputField4">Contact No.</label>
              <input
                id="inputField4"
                v-model="selected_user.contact_no"
                type="text"
                class="form-control"
                placeholder="+6281234567890"
              />
            </div>
          </div>
          <div class="col-sm-6">
            <div class="mb-3">
              <label for="inputField5">Select Role <span class="text-danger small">*</span></label>
              <select
                id="inputField5"
                v-model="selected_user.role_id"
                class="form-control"
                :class="{
                  'is-invalid': submitted && $v.selected_user.role_id.$error,
                }">
                <option :value="role.id" v-for="(role, index) in roles" :key="`role_${index}`">{{role.name}}</option>
              </select>
              <div v-if="submitted && $v.selected_user.role_id.$error" class="invalid-feedback">
                <span v-if="!$v.selected_user.role_id.required">Role is required.</span>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="mb-3">
              <label for="inputField6">Select Gender</label>
              <select
                id="inputField6"
                v-model="selected_user.gender_id"
                class="form-control">
                <option :value="gender.id" v-for="(gender, index) in genders" :key="`gender_${index}`">{{gender.name}}</option>
              </select>
            </div>
          </div>
          <!-- <div class="col-md-12" v-if="selected_user.role_id !== 2">
            <div class="mb-3">
              <label>Assign Room</label>
              <multiselect v-model="selected_user.rooms" :options="roomList" :multiple="true" :close-on-select="false" :clear-on-select="false"
                 :preserve-search="true" placeholder="Select room(s)" label="name" track-by="name">
                <template #selection="{ values, search, isOpen }">
                  <span class="multiselect__single"
                    v-if="values.length"
                    v-show="!isOpen">{{ values.length }} options selected</span>
                </template>
              </multiselect>
            </div>
          </div> -->
        </div>
        <div class="col-12 right">
          <button :disabled="isLoadingPost" class="btn btn-primary me-2" type="submit">Submit</button>
          <!-- <button :disabled="isLoadingPost" class="btn btn-light" @click="$bvModal.hide('modal-user')">Close</button> -->
        </div>
      </form>
    </b-modal>
  </Layout>
</template>